import { IconDrag } from '@components/icons';
import { InputCheckbox } from '@components/input-checkbox';
import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import classNames from 'classnames';

export interface AdmissionCardInteractiveProps {
  id: string;
  checked?: boolean;
  isDragActive?: boolean;
  isSelectActive?: boolean;
  isMultiSelectActive?: boolean;
  listeners?: SyntheticListenerMap;
  attributes?: DraggableAttributes;
  onChange?: (e: boolean) => void;
}

export const AdmissionCardInteractive = ({
  id,
  checked,
  isDragActive = false,
  isSelectActive,
  isMultiSelectActive,
  listeners,
  attributes,
  onChange,
}: AdmissionCardInteractiveProps) => {
  return (
    <>
      {isDragActive && (
        <div
          {...listeners}
          {...attributes}
          style={{ touchAction: 'none' }}
          className='flex items-start sm:items-center pr-0.5 sm:pr-4 cursor-move'>
          <IconDrag className='text-tertiary w-5 h-5' />
        </div>
      )}
      {(isSelectActive || isMultiSelectActive) && (
        <div className={classNames('flex items-start sm:items-center pr-3 sm:pr-4')}>
          <InputCheckbox
            name={id}
            value={!!checked}
            type={isMultiSelectActive ? 'checkbox' : 'radio'}
            rounded={!isMultiSelectActive}
            onChange={onChange}
          />
        </div>
      )}
    </>
  );
};
